import { NewsCenter, PublicLocale } from "../../../types";

export const SET_INITIAL_STATE = "SET_INITIAL_STATE";
export const SET_LOCALE = "SET_LOCALE";

export interface NewsCenterState {
  currentLocale: PublicLocale;
  newsCenter: NewsCenter;
  customDomainEnabled: boolean;
}

export interface SetInitialStateAction {
  type: typeof SET_INITIAL_STATE;
  newsCenter: NewsCenter;
}

interface SetLocaleAction {
  type: typeof SET_LOCALE;
  locale: PublicLocale;
}

export type NewsCenterActionTypes = SetInitialStateAction | SetLocaleAction;
